// ============================================================================
// Player-owned status & caption types (no domain-enum coupling)
// ============================================================================
/** Player readiness, decoupled from any domain status. "processing" = still
 *  preparing (transcode/probe); "ready" = playable. */
export var MediaPlayerStatus;
(function (MediaPlayerStatus) {
    MediaPlayerStatus["Ready"] = "ready";
    MediaPlayerStatus["Processing"] = "processing";
})(MediaPlayerStatus || (MediaPlayerStatus = {}));
/** video.js remote text-track kind (W3C <track> kinds). */
export var MediaPlayerTextTrackKind;
(function (MediaPlayerTextTrackKind) {
    MediaPlayerTextTrackKind["Captions"] = "captions";
    MediaPlayerTextTrackKind["Subtitles"] = "subtitles";
})(MediaPlayerTextTrackKind || (MediaPlayerTextTrackKind = {}));
